//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import React from 'react';

import ThresholdStatus from '@catalog-ingestion/components/review-panel/ThresholdStatus';

export const ThresholdFailedDescription = () => {
  return (
    <ThresholdStatus
      iconName='alarm'
      iconClass='cu-color-error'
      message='Oh no! Over 10% of your catalog failed'
      information='We recommend fixing your errors and re-connecting your catalog.'
    />
  );
};

export default ThresholdFailedDescription;
